import { observer } from 'mobx-react';
import React from 'react';
import { Navigate, useOutlet } from 'react-router-dom';

export interface IOutletWithDefaultRedirect {
    to: string
}
/**
 * This component exists for the purpose of when you need a ExtRouteObject to server an outlet and have it render a child in it's root and you want accessing the root parent route to redirect to a default child route
 * Previously, I solved this problem by having redundant child routes but this causes MatchRoutes to return both routes as matches which was kind of difficult to deal with.
 *
 * So imagine this scenario
 *   /admin -> Outlet
 *       users -> UsersView
 *       locations -> LocationsView
 *
 * If you go to /admin without specifying /users or /locations it will render a blank page because nothing is in the Outlet on /admin
 * So previously I'd create a new child route that has no path defined and just render a Navigate element that redirects to locations as the default child route
 *
 * This component solves for that without having to have the child route.  Simply use an OutletWithDefaultRedirect with a to property to where you want it to redirect when there is no child route specified.
 *
 */
export const OutletWithDefaultRedirect = observer(({to}: IOutletWithDefaultRedirect) => {
    const outletElement = useOutlet();
    if (outletElement)
        return outletElement;
    return (<Navigate to={to} />)
});
